<template>
    <div class="" v-if="currentBadge !== null">
        <template v-for="badge in badgesCollection" v-if="badge.badge_id !== null">
            <div class="row" :class="{'transparent': badge.badge_id > currentBadgeId}">
                <div class="col-md-3 col-sm-3 col-xs-3">
                    <img :src="absolutePath(badge.img_name)" width="60px">
                </div>
                <div class="col-md-8 col-sm-8 col-xs-8">
                    <h5>{{ badge.name|trans }}</h5>
                    <span class="points">{{ badge.points }} {{'points'|trans}}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
	import badgesCollection from "./badges_collection";

	export default {
		props: {
			badgeData:null
        },
		data() {
			return {
				isFetchingData : true,
				currentBadgeId: null,
				currentBadge : null,
				currentPoints: null,
				nextBadge: null,
				badges: badgesCollection,
                defaultNumberOfSteps : 1,
			}
		},
		created() {
			this.currentBadgeId = this.badgeData.badge_id;
			this.currentPoints = this.badgeData.points;
			this.currentBadge = this.getCurrentBadge();
			this.nextBadge = this.getNextBadge();
		},
		methods: {
			absolutePath(image) {
				return process.env.VUE_APP_API_BASE_URL_ASSETS + "/images/badges/" + image;
			},
			getCurrentBadge() {
				return this.badges.find((element) => {
					if(this.currentBadgeId === null ){
						return element.badge_id === this.currentBadgeId;
                    }
					return element.badge_id === parseInt(this.currentBadgeId);
				});
			},
			getNextBadge() {
				return this.badges.find((element, index, array) => {
					if(this.currentBadgeId === null ){
						return element.badge_id === this.currentBadgeId;
					}
                    if(this.badges[this.badges.length - 1].badge_id === parseInt(this.currentBadgeId)){
                        return 	this.currentBadgeId; // ???
                    }
					return element.badge_id === parseInt(this.currentBadgeId) + 1;
				});
			},
            isNextBadge(badge){
				if(badge.badge_id >= badgesCollection[badgesCollection.length - 1].badge_id &&
                    badgesCollection[badgesCollection.length - 1].badge_id === this.currentBadgeId){
					return true;
				}
                return badge.badge_id === this.currentBadgeId+1;
            }
		},
		computed: {
			badgesSteps() {
				let badgesStep = [] ;
				for(let i=0; i<this.defaultNumberOfSteps; i++){
                    badgesStep.push({'points':this.currentPoints});
                }
				return badgesStep;
			},
			badgesStepsReversed() {
				let badges = [...this.badges];
				return badges.reverse();
			},
			badgesCollection() {
				return [...this.badges];
			}
		},
	}

</script>

<style scoped lang="scss">
    .badge-stepper-container {
        height: 300px;
        width: 100%;
        position: relative;
        border-radius: 8px;
        text-align: center;

        .badges-stepper {
            width: 100%;
            position: absolute;
            bottom: 0;
            padding: 0;
            display: flex;
            border-radius: 8px;

            .stepper {
                background-color: lightskyblue;
                height: 6px;
                border-radius: 8px;
            }

            .badge-step {
                position: relative;
                flex: auto;
                display: inline-flex;
                height: 6px;
                background-color: #d0d0d0;
                margin: 3px;
                border-radius: 8px;
            }

            .badge-empty {
                background-color: #d0d0d0;
            }

            .badge-step-current {
                position: relative;
            }


        }

        .points {
            color: lightslategray;
        }
    }
    .current-badge-image {
        width: 230px;
        margin: 0 auto;
    }
    .next-badge-image {
        width: 18px;
        margin: 0 auto;
        position: absolute;
        bottom: 22px;
        right: 0;
    }
    .transparent{
        opacity: 0.3;
    }
    .negatif-number{
        color:red;
    }
</style>
